<template>
  <el-dialog
    ref="printDialog"
    v-dialogDrag
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    class="h720_dialog abow_dialog"
    width="1100px"
    :before-close="modalClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @open="handleOpen('printDialog')"
  >
    <section ref="print">
      <h3>制作费用报销明细单</h3>
      <table
        width="100%"
        class="title"
      >
        <td align="left">
          报销日期: {{ reimburseDate }}
        </td>
        <td align="center">
          付款单位: {{ printData.paymentVoucher.payerName }}
        </td>
        <td align="right">
          支付方式: {{ printData.paymentVoucher.payMethodValue +'(' + printData.paymentVoucher.payChannelValue + ')' }}
        </td>
      </table>
      <table
        class="table"
        width="100%"
      >
        <tr style="height: 36px;">
          <td
            width="50"
            class="bold"
          >
            序号
          </td>
          <td
            width="150"
            class="bold"
          >
            科目
          </td>
          <td class="bold">
            项目名称
          </td>
          <td
            class="bold"
            width="100"
          >
            项目日期
          </td>
          <td
            class="bold"
            width="70"
          >
            区域
          </td>
          <td
            class="bold"
            width="100"
          >
            应付金额(元)
          </td>
          <td
            class="bold"
            width="100"
          >
            支付金额(元)
          </td>
        </tr>
        <tbody
          v-for="(data, index) in printDetailData"
          :key="index"
          width="100%"
        >
          <tr class="table_data">
            <td rowspan="2">
              {{ index + 1 }}
            </td>
            <td>
              {{ data.subject }}
            </td>
            <td>
              {{ data.projectName }}
            </td>
            <td>
              {{ data.projectDate }}
            </td>
            <td>
              {{ data.areaName }}
            </td>
            <td>
              {{ data.payableAmount }}
            </td>
            <td>
              {{ data.amount }}
            </td>
          </tr>
          <tr class="table_data">
            <td
              colspan="6"
              style="text-align: left; padding-left:5px"
            >
              {{ data.detailInfo !== null && data.detailInfo !== '' && data.detailInfo !== undefined ? '明细: ' + data.detailInfo : '' }}
            </td>
          </tr>
        </tbody>
        <tr style="height: 28px;">
          <td
            colspan="6"
            class="bold"
          >
            合计金额(元)
          </td>
          <td>{{ Number(printData.paymentVoucher.payAmount).toFixed(2) }}</td>
        </tr>
      </table>
      <table class="table">
        <tr style="height: 28px;">
          <td
            width="25%"
            style="border-top:none"
            class="bold"
          >
            报销人
          </td>
          <td
            width="25%"
            style="border-top:none"
            class="bold"
          >
            复核人
          </td>
          <td
            width="25%"
            style="border-top:none"
            class="bold"
          >
            审核人
          </td>
          <td
            width="25%"
            style="border-top:none"
            class="bold"
          >
            领款人
          </td>
        </tr>
        <tr style="height: 40px;">
          <td />
          <td />
          <td />
          <td />
        </tr>
      </table>
    </section>

    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        type="primary"
        plain
        @click="printFun"
      >
        打印
      </el-button>
      <el-button @click="modalClose">
        关闭
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 数据请求
import { printPaymentVoucherApi } from '@/api/paymentVoucher'

export default {
  components: {},
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: null
    },
    themeColor: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      printData: {},
      printDetailData: [], // 报销单明细内容
      reimburseDate: ''
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.printData = {}
        this.printDetailData = []
        this.reimburseDate = ''
        this.loadReimburseOrderData()
      }
    }
  },
  methods: {
    // 初始化报销单数据
    loadReimburseOrderData () {
      printPaymentVoucherApi({ id: this.dataId }).then((response) => {
        const { data } = response
        this.printData = data
        this.reimburseDate = ' ' + this.printData.reimburseYear + ' 年 ' + this.printData.reimburseMonth + ' 月 ' + this.printData.reimburseDay + ' 日'
        // this.printDetailData = this.printData.reimburseDetailList
        data.reimburseDetailList.forEach(item => {
          this.printDetailData.push({ subject: item.payablePayment.paymentSubjectValue, projectName: item.payablePayment.projectName, projectDate: item.payablePayment.projectDateValue, areaName: item.payablePayment.businessProvinces, payableAmount: Number(item.payablePayment.payableAmount).toFixed(2), amount: Number(item.payablePayment.amount).toFixed(2), detailInfo: item.detailInfo })
        });
        let maxLength = 3
        if (this.printDetailData.length < maxLength) {
          let fillingLength = maxLength - this.printDetailData.length
          for (var i = 0; i < fillingLength; i++) {
            this.printDetailData.push({ subject: '', projectName: '', amount: '' })
          }
        }
      })
    },
    // 打印
    printFun () {
      this.$print(this.$refs.print)
    },
    // 关闭弹窗
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
    },
  }
}
</script>
<style lang="scss"  scoped>
body {
  padding: 0;
  margin: 0;
  font-size: 12px;
}
table {
  border-spacing: 0;
  border-collapse: collapse;
  width: 100%;
}
.title {
  margin-bottom: 10px;
  font-size: 12px;
}
.table_head {
  height: 32px;
}
.table_data {
  height: 40px;
  font-size: 12px;
}
.table td {
  background: #fff;
  border: 2px solid rgb(0, 0, 0);
  text-align: center;
  height: 20px;
  padding: 0;
}
.table td.bgColor {
  background: #b3e1ff;
}
.table-inner td {
  border-right: 0;
  border-bottom: 0;
}
.table-inner tr:first-child td,
.tabT tr:first-child td {
  border-top: none;
}
.table-inner tr td:first-child {
  border-left: none;
}
h3 {
  font-size: 16px;
  text-align: center;
}
.bold {
  font-size: 14px;
  font-weight: bold;
}
</style>
